import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Checkbox } from 'antd'
import { formatDateTime, getMenuTypeName, getReturnOrderStatus, numberWithComma } from 'helpers/format'
import { selectCurrentUser } from 'Store/user/selector'
import styled from 'styled-components'
import theme, { MyTheme } from 'Components/common/Theme'
import { menuReturnChannel, menuReturnPaymentTypes } from 'helpers/constanst'
import { TableListPage } from 'Components/common/Table'
import { Pagination } from 'Components/Pagination'
import { cloneDeep } from 'lodash'
import { StatusTag } from 'Components/utilities'
import { returnListAPI } from 'Store/return-order/api'
import { selectReturnList, selectReturnListEvent } from 'Store/return-order/selector'
import ReturnDetail from '../../OrderReturns/detail'
import { ReturnData, ReturnListReq } from 'Store/return-order/types'

type Props = ReduxProps & {
  customerID: number
  selectedSaleOrder: ReturnData[]
  setSelectedSaleOrder: (orders: ReturnData[]) => void
  onSuccess?: () => void
}

const ReturnSaleOrder: React.FunctionComponent<Props> = props => {
  const {
    currentUser,
    listEvent,
    list,
    customerID,
    selectedSaleOrder,
    setSelectedSaleOrder,
    onSuccess,
  } = props

  const initFilter = {
    order_by: 'created_at',
    sort: 'asc',
  }

  const dispatch = useDispatch()
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const [selectedID, setSelectedID] = useState(0)
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 20,
  })

  const meta = list?.meta
  const datas = list?.data

  useEffect(() => {
    if (currentUser?.accessToken && customerID > 0) {
      onGetList()
    }
  }, [pagination, customerID])

  const onGetList = (): void => {
    const req: ReturnListReq = {
      keyword: '',
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      start_date: '',
      end_date: '',
      sort: filter.sort || 'desc',
      order_by: filter.order_by || 'created_at',
      status: 'pending',
      customer_id: customerID,
    }

    dispatch(returnListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  const isSelected = (id: number) => {
    const data = selectedSaleOrder.find(item => item?.id === id)
    return data ? true : false
  }

  const removeID = (data: ReturnData) => {
    return selectedSaleOrder.filter(item => item.id !== data.id)
  }

  const onSelect = (data: ReturnData) => {
    let newSelect = cloneDeep(selectedSaleOrder) || []
    if (isSelected(data.id)) {
      newSelect = removeID(data)
    } else {
      newSelect.push({ ...data })
    }
    setSelectedSaleOrder([...newSelect])
  }

  const renderStatus = (status: string) => {
    const statusResult = getReturnOrderStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onClickViewDetail = (id: number) => {
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const columns = [
    {
      title: 'เลือก',
      dataIndex: 'id',
      key: 'id',
      width: '50px',
      // eslint-disable-next-line react/display-name
      render: (id: number, record: ReturnData) => (
        <Checkbox onChange={() => onSelect(record)} checked={isSelected(id)} />
      ),
    },
    {
      title: 'เลขที่สั่งซื้อ',
      dataIndex: 'order_no',
      key: 'order_no',
      width: '180px',
      // eslint-disable-next-line react/display-name
      render: (val: string, record: ReturnData) => (
        <LinkNo onClick={() => onClickViewDetail(record.id)}>{val}</LinkNo>
      ),
      sorter: true,
    },
    {
      title: 'ลูกค้า',
      dataIndex: 'customer_fullname',
      key: 'customer_fullname',
      sorter: true,
    },
    {
      title: 'ยอดเงินคืนสุทธิ',
      dataIndex: 'total_amount',
      key: 'total_amount',
      sorter: true,
      align: 'right',
      // eslint-disable-next-line react/display-name
      render: (val: number) => {
        return <WarningText>{numberWithComma(val, true)}</WarningText>
      },
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      width: '30px',
    },
    {
      title: 'ช่องทางการขาย',
      dataIndex: 'channel',
      key: 'channel',
      sorter: true,
      render: (channel: string) => getMenuTypeName(menuReturnChannel, channel || ''),
    },
    {
      title: 'วันที่รับคืนสินค้า',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      width: '100px',
      render: (val: string) => formatDateTime(val || ''),
    },
    {
      title: 'ช่องทางการคืนเงิน',
      dataIndex: 'return_type',
      key: 'return_type',
      sorter: true,
      render: (return_type: string) => getMenuTypeName(menuReturnPaymentTypes, return_type || ''),
    },
    // {
    //   title: 'สถานะการคืนเงิน',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: renderStatus,
    //   sorter: true,
    // },
    {
      title: 'รับคืนโดย',
      dataIndex: 'officer',
      key: 'officer',
      sorter: true,
    },
  ]

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const ReturnOrderDetailDrawer = (
    <ReturnDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={() => {
        onGetList()
      }}
      onPaymentSuccess={onSuccess}
    />
  )

  return (
    <>
      {ReturnOrderDetailDrawer}
      <TableListPage
        columns={columns}
        datas={datas || []}
        isLoading={listEvent.IsLoading}
        paginationContent={PaginationContent}
        size="small"
        offsetHeader={-25}
        onSort={(field: string, order: string) => {
          onSort(field, order)
        }}
      />
    </>
  )
}

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`
const WarningText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectReturnList(state),
    listEvent: selectReturnListEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ReturnSaleOrder)
